/**
 * Rulebook shipped with the app. The live copy lives in Supabase
 * (`public.league_rules`) so the commissioner can edit it from `/rules`; this is
 * what the page shows before that migration has run, or if the fetch fails.
 * Keep it in sync with the seed in
 * `supabase/migrations/20261016130000_league_rules.sql`.
 */
export const RULES_SLUG = "soccer";

export const DEFAULT_RULES_TITLE = "HADAF Soccer League — Official Rulebook";

export const DEFAULT_RULES_MARKDOWN = `# HADAF Soccer League — Official Rulebook

## Equipment

1. All players must wear jerseys, unless the referee decides otherwise.
2. Shin guards are not required.

## Rosters & Eligibility

3. All rosters must be finalized before the playoffs. IDs will be checked.
4. Every player must sign a waiver before playing.
5. Players play at their own risk.

## Match Format

6. Games are two 25-minute halves with a 5-minute break, at the referee's discretion. No extensions if a team is late.
7. Substitutions are on the fly.

## Cards & Discipline

8. Yellow card: the player leaves the field for 2 minutes, and no one may sub in for those 2 minutes.
9. Second yellow (red): the player leaves the field for 5 minutes, no one may sub in, and that player is out for the remainder of the game plus the following week. The same applies to straight red cards.
10. Any player receiving a card must leave the field immediately. Failure to do so can result in a forfeit, at the referee's discretion.
11. Red cards carry a suspension for the next game. Suspensions can be appealed by reaching out to the commissioner.

## Conduct

12. No slide tackles.
13. No pass-backs to the goalkeeper.
14. Fighting, cussing at players, stalling game time to argue with the referee, unregistered players running onto the field, and physical altercations can all lead to player suspensions, bans, and the same for teams — at the commissioner's discretion.

*The commissioner reserves the right to interpret these rules and issue rulings on any situation not explicitly covered.*

Play hard. Play fair.
`;
